import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  IconButton
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

interface Key {
  username: string;
  rolName: string;
  expirationTime: string;
  sslSerialNumber: string;
}

const Users: React.FC = () => {
  const [keys, setKeys] = useState<Key[]>([]);
  const navigate = useNavigate();
  const [csrfToken, setCsrfToken] = useState<string | null>(null);
  const [host, setHost] = useState<string>('');

  const getKeys = async (host: string) => {
    try {
      const response = await axios.get(`${host}/userManagement/users/`);
      setKeys(response.data);
    } catch (error) {
      console.error('There was an error fetching the keys!', error);
    }
  };

  const handleCreateKeys = () => {
    navigate('/keyform');
  };

  const handleDeleteKey = async (sslSerialNumber: string) => {
    try {
      const response = await axios.delete(`${host}/userManagement/users/${sslSerialNumber}`, {
        headers: {
          'X-CSRFToken': csrfToken,
          'Content-Type': 'application/json',
        },
      });
      setKeys(response.data);
    } catch (error) {
      console.error('There was an error deleting the key!', error);
    }
  };

  const handleViewDetails = (sslSerialNumber: string) => {
    navigate(`/user/${sslSerialNumber}`);
  };

  const getCsrf = async (host: string) => {
    try {
      const response = await axios.get(`${host}/csfr/`);
      const token = response.data.csrfToken;
      setCsrfToken(token);
      console.log('CSRF Token:', token);
    } catch (error) {
      console.error('Error fetching CSRF token:', error);
    }
  };

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch('/config.json');
        const config = await response.json();
        setHost(config.host);
        console.log('Host loaded from config:', config.host);
        await fetchData(config.host);
      } catch (error) {
        console.error('Error loading config:', error);
      }
    };

    const fetchData = async (host: string) => {
      await getCsrf(host);
      await getKeys(host);
    };

    fetchConfig();
  }, []);

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 2 }}>
        <Button variant="contained" color="primary" onClick={handleCreateKeys}>
          Crear llaves
        </Button>
      </Box>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Key Name</TableCell>
              <TableCell>Role Name</TableCell>
              <TableCell>Expiration Time</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {keys.map((key) => (
              <TableRow key={key.sslSerialNumber} onClick={() => handleViewDetails(key.sslSerialNumber)}>
                <TableCell>{key.username}</TableCell>
                <TableCell>{key.rolName}</TableCell>
                <TableCell>{key.expirationTime}</TableCell>
                <TableCell>
                  <IconButton
                    aria-label="delete"
                    onClick={(e) => {
                      e.stopPropagation(); // Evita que el evento de clic en la fila también se dispare
                      handleDeleteKey(key.sslSerialNumber);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Users;
